import { render, staticRenderFns } from "./IconScale.vue?vue&type=template&id=61479252&scoped=true"
import script from "./IconScale.vue?vue&type=script&lang=js"
export * from "./IconScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61479252",
  null
  
)

export default component.exports